import { render, staticRenderFns } from "./AutoRotate.vue?vue&type=template&id=be0ae9bc&scoped=true"
import script from "./AutoRotate.vue?vue&type=script&lang=js"
export * from "./AutoRotate.vue?vue&type=script&lang=js"
import style0 from "./AutoRotate.vue?vue&type=style&index=0&id=be0ae9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0ae9bc",
  null
  
)

export default component.exports